import * as ActionTypes from './constants';

export const defaultState = () => {
  return {
    createdAt: null,
    isReturningUser: null,
    hasSignedUpForNewsletter: false,
    searchUserId: null,
    saveSearchConfirmed: false,
    hasSeenProfileInfo: false,
    isNotificationIndicatorVisible: false,
  };
};

export function user(state = defaultState(), action) {
  const { type, payload } = action;

  if (type === ActionTypes.SET_USER_CREATED) {
    return { ...state, createdAt: payload.timestamp };
  }

  if (type === ActionTypes.SET_USER_STATE) {
    return { ...state, isReturningUser: payload.isReturningUser };
  }

  return state;
}
